const exploreCol = [
  { label: "新片速递", href: "#new" },
  { label: "口碑热榜", href: "#rank" },
  { label: "题材片库", href: "#genre" },
  { label: "编辑精选片单", href: "#curated" },
];

const aboutCol = [
  { label: "影评专栏", href: "#review" },
  { label: "观影指南", href: "#faq" },
  { label: "关于我们", href: "#about" },
  { label: "联系我们", href: "#contact" },
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-gradient-to-b from-primary-900 to-primary-950 text-white">
      <div className="container-x py-14 md:py-16">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1.4fr)_repeat(2,minmax(0,0.7fr))_minmax(0,1fr)]">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-500 text-foreground-950">
                <i className="ri-film-fill text-xl" aria-hidden="true"></i>
              </span>
              <span className="leading-none">
                <span className="block font-heading text-xl font-black">吃瓜影院</span>
                <span className="mt-1 block text-[10px] tracking-[0.2em] text-white/60">选片 · 观影指南</span>
              </span>
            </a>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/70">
              汇聚最新电影、高分佳片、热门题材与编辑片单，用认真的选片态度，陪你找到下一部心头好。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["wechat", "weibo", "douban", "bilibili"].map((s) => (
                <span key={s} className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white/80 transition-colors hover:bg-accent-500 hover:text-foreground-950">
                  <i className={"ri-" + s + "-line text-base"} aria-hidden="true"></i>
                </span>
              ))}
            </div>
          </div>

          <nav aria-label="探索栏目">
            <h3 className="text-sm font-bold tracking-wide text-white/90">探索栏目</h3>
            <ul className="mt-4 space-y-3">
              {exploreCol.map((l) => (
                <li key={l.href + l.label}>
                  <a href={l.href} className="inline-flex items-center gap-2 text-sm text-white/65 transition-colors hover:text-accent-300">
                    <i className="ri-arrow-right-s-line text-base" aria-hidden="true"></i>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="关于吃瓜影院">
            <h3 className="text-sm font-bold tracking-wide text-white/90">了解我们</h3>
            <ul className="mt-4 space-y-3">
              {aboutCol.map((l) => (
                <li key={l.href + l.label}>
                  <a href={l.href} className="inline-flex items-center gap-2 text-sm text-white/65 transition-colors hover:text-accent-300">
                    <i className="ri-arrow-right-s-line text-base" aria-hidden="true"></i>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="text-sm font-bold tracking-wide text-white/90">观影提醒</h3>
            <p className="mt-4 rounded-2xl border border-white/10 bg-white/5 p-4 text-sm leading-relaxed text-white/70">
              吃瓜影院仅提供电影信息、片单推荐与观影指南，不提供任何盗版下载或侵权在线资源。请通过正规院线与授权平台欣赏影片。
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row">
          <p className="text-xs text-white/55">© 2026 吃瓜影院 Chigua Cinema. 本站内容仅供选片参考，请支持正版电影。</p>
          <p className="flex items-center gap-1.5 text-xs text-white/55">
            <i className="ri-cup-line" aria-hidden="true"></i>
            认真做选片指南，与你一起看好电影
          </p>
        </div>
      </div>
    </footer>
  );
}